import { useState } from "react"
import UserTabs from "../../../components/UserPortalComponents/UserTabs/UserTabs"
import AccountDeletion from "./AccountDeletion/AccountDeletion"
import Notifications from "./Notifications/Notifications"

const Settings = () => {

  const tabs = ['Account deletion', 'Notifications']
  const [activeTab, setActiveTab] = useState(tabs[0])

  const renderComponent = () => {
    switch (activeTab) {
      case "Account deletion":
        return <AccountDeletion />
      case "Notifications":
        return <Notifications />
      default:
        return null
    }
  }

  return (
    <div className="m-3">
      
      <UserTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {renderComponent()}

    </div>
  )
}

export default Settings
